module.exports = __webpack_public_path__ + "static/logo40.3e1d4d08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo40.jpg
// module id = 795
// module chunks = 79611799117203 84521481881339